import { Box, Typography, Stack } from '@mui/material';
import { TerminalImage } from '@/components/TerminalImage';
import { styled } from '@mui/material/styles';
import { ProfileActionButton } from './ProfileActionButton';

const MetaBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
}));

const StatusRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '0.7rem',
  letterSpacing: '0.12em',
  color: theme.palette.text.secondary,
}));

export function ProfileHeader({
  name,
  title,
  location,
  avatarUrl,
  status = 'ACTIVE',
}: {
  name: string;
  title: string;
  location?: string;
  avatarUrl: string;
  status?: 'ACTIVE' | 'IDLE' | 'OFFLINE';
}) {
  return (
    <Stack direction="row" gap={3} alignItems="center">
      <TerminalImage src={avatarUrl} alt={`${name} profile`} height="10rem" />

      <MetaBlock>
        <Typography variant="h5" sx={{ color: 'primary.main' }}>
          {name}
        </Typography>

        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {title}
        </Typography>

        {location && (
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            LOCATION: {location}
          </Typography>
        )}

        <StatusRow>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor:
                status === 'ACTIVE'
                  ? 'primary.main'
                  : status === 'IDLE'
                    ? 'warning.main'
                    : 'error.main',
              boxShadow: '0 0 6px currentColor',
            }}
          />
          STATUS: {status}
        </StatusRow>
        <ProfileActionButton
          href="https://linkedin.com/in/jovannimosca"
          label="VIEW FULL PROFILE"
        />
      </MetaBlock>
    </Stack>
  );
}
